/**
 * `/merchandising/orders/$orderId` — Garment Order view (ADR-0039): size
 * breakdown, buyer, delivery, the linked Style File, and the lifecycle actions
 * (edit / link style / close / cancel).
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { GarmentOrderDetailPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/orders/$orderId/")({
  component: OrderDetailRoute,
});

function OrderDetailRoute() {
  const { orderId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Orders", to: "/merchandising/orders" },
        { label: "Order" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <GarmentOrderDetailPage orderId={orderId} />
    </WorkspaceShell>
  );
}
